import React from "react";
import image1 from '../../Images/seo_illustration_under_150kb.webp';
import image2 from '../../Images/new3/Component 16.png';
import image3 from '../../Images/new3/Component 2.png';
import image4 from '../../Images/new3/Component 3.png';
import image8 from '../../Images/new3/Component 4.png';
import image9 from '../../Images/new3/Component 9.png';
import image10 from '../../Images/new3/Component 1.png';
import image5 from '../../Images/new3/Container.png';
import image6 from '../../Images/img/Group 20.png';
import image7 from '../../Images/img/Group 7.png';
import image81 from '../../Images/img/Group 36.png';
import image91 from '../../Images/img/Group 36.png';
import useInViewOnce from "./useInViewOnce";
const WhySeo = () => {
  
    return (
        <div className="choose1 sp w-[90%] 2xl:w-[70%] mx-auto">
            <h2 className="h2-mb h2-md h2-lg h2-2xl text-center mt-12 mb-4 md:m-12">
               Wir legen Wert auf SEO

            </h2>
            <div className="max-w-[100%] mx-auto px-4">

                <div className="flex justify-center">
                    <div className="w-full ">
                        <div className="ops-card">
                            <div className="flex flex-col lg:flex-row items-center gap-8">

                                {/* LEFT IMAGE */}


                                {/* RIGHT CONTENT */}
                                <div className="w-full lg:w-1/2">
                                    <div className="ops-content">
                                        {/* <h3 className="ops-title">
                                            Benutzerfreundliches <br /> Design
                                        </h3> */}
                                        <h3 className="h3-mb h3-md h3-lg h3-2xl mb-4">
                                            WARUM IST SEO SO WICHTIG?
                                        </h3>

                                        <p className="text-gray-600 mb-4">
                                            SEO (Suchmaschinenoptimierung) ist der Schlüssel, um online sichtbar zu sein. In einer Welt, in der Millionen von Suchanfragen täglich gestellt werden, ist es entscheidend, dass deine Website in den Suchergebnissen ganz oben erscheint.
                                        </p>

                                        <div className="ops-list">
                                            <div
                                                className={`ops-item`}
                                            >

                                                <div className="icon purple">
                                                    <img src={image6} alt="" />
                                                </div>
                                                <div>
                                                    <p className="font-bold">92% der potenziellen Kunden nutzen Suchmaschinen.</p>



                                                </div>

                                            </div>

                                            <div
                                                className={`ops-item `}
                                            >

                                                <div className="icon red">
                                                    <img src={image7} alt="" />
                                                </div>
                                                <div>
                                                    <p className="font-bold">der Kunden beachten maximal die ersten 3 Ergebnisseiten.</p>



                                                </div>
                                            </div>

                                            <div
                                                className={`ops-item `}
                                            >

                                                <div className="icon green">
                                                    <img src={image91} alt="" />
                                                </div>
                                                <div>
                                                    <p className="font-bold">der suchenden Konsumenten haben Kaufinteresse.</p>



                                                </div>
                                            </div>
                                            <div
                                                className={`ops-item `}
                                            >

                                                <div className="icon green">
                                                    <img src={image81} alt="" />
                                                </div>
                                                <div>
                                                    <p className="font-bold">der Onlinenutzer suchen mindestens 1x im Monat nach einem Dienstleister</p>



                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-full lg:w-1/2">
                                    <div className="ops-image-wrapper image-anime reveal overflow-visible">
                                        <img
                                            src={image1}
                                            alt=""
                                            className="w-full h-auto ops-main-image"
                                        />

                                        {/* Top Badge */}
                                        <div className={`ops-badge top-badge hidden md:block `}>
                                            <div className="flex items-center gap-2">
                                                <img src={image2} alt="" />
                                                <div className="grid">
                                                    <span className="text-muted font-bold text-sm">
                                                        ABTEILUNG
                                                    </span>
                                                    <strong>SEO / Suchmaschinenoptimierung
                                                    </strong>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Accuracy Badge */}
                                        {/* <div class={`ops-badge accuracy-badge right-ops`}>
                                            <div class="flex align-center items-center gap-2">
                                                <img src={image8} alt="" />
                                                <span> RELEVANZ</span>
                                            </div>

                                        </div> */}
                                        {/* <div class={`ops-badge accuracy-badge right-ops1 `}>
                                            <div class="flex align-center items-center gap-2">
                                                <img src={image9} alt="" />
                                                <span> TRAFFIC</span>
                                            </div>

                                        </div> */}
                                        {/* <div class={`ops-badge accuracy-badge right-ops2 `}>
                                            <div class="flex align-center items-center gap-2">
                                                <img src={image10} alt="" />
                                                <span> BESUCHER</span>
                                            </div>

                                        </div> */}


                                        <div class={`ops-stats-card hidden md:block right-card `}>

                                            <div className="flex items-center gap-2">
                                                <img src={image4} alt="" />
                                                <div className="flex items-center gap-2">
                                                    <span className="text-muted font-bold whitespace-nowrap">
                                                        Realisierte
                                                        Projekte
                                                    </span>
                                                    <span className="bg-black text-white px-2 py-1 rounded-full">
                                                        Erfolgreich
                                                    </span>
                                                </div>
                                            </div>

                                            <h3 className="text-5xl font-bold">161+</h3>


                                            <div className="bars">
                                                <img src={image5} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhySeo;
